import { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import Footer from "./Footer";
import Header from "./Header";
import opticalCharRecImg2 from "./assets/img/opticalCharRecImg-2.png";

import PayPal from "./assets/img/products/Logos/PaymentGateways/PayPal.png";
import stripe from "./assets/img/products/Logos/PaymentGateways/stripe.png";
import square from "./assets/img/products/Logos/PaymentGateways/square.png";
import Authorizenet from "./assets/img/products/Logos/PaymentGateways/Authorizenet.png";
import AmazonPay from "./assets/img/products/Logos/PaymentGateways/AmazonPay.png";

import Salesforce from "./assets/img/products/Logos/CRM/Salesforce.png";
import HubSpotCRM from "./assets/img/products/Logos/CRM/HubSpotCRM.png";
import ZohoCRM from "./assets/img/products/Logos/CRM/ZohoCRM.png";
import MicrosoftDynamics from "./assets/img/products/Logos/CRM/MicrosoftDynamics.png";

import Mailchimp from "./assets/img/products/Logos/MarketingAutomation/Mailchimp.png";
import ActiveCampaign from "./assets/img/products/Logos/MarketingAutomation/ActiveCampaign.png";
import Marketo from "./assets/img/products/Logos/MarketingAutomation/Marketo.png";
import Klaviyo from "./assets/img/products/Logos/MarketingAutomation/Klaviyo.png";

import GoogleAnalytics from "./assets/img/products/Logos/AnalyticsandReporting/GoogleAnalytics.png";
import FacebookPixel from "./assets/img/products/Logos/AnalyticsandReporting/FacebookPixel.png";
import Hotjar from "./assets/img/products/Logos/AnalyticsandReporting/Hotjar.png";
import PowerBI from "./assets/img/products/Logos/AnalyticsandReporting/PowerBI.png";
import Tableau from "./assets/img/products/Logos/AnalyticsandReporting/Tableau.png";

import NetSuite from "./assets/img/products/Logos/InventoryOrderManagemnt/NetSuite.png";
import TradeGecko from "./assets/img/products/Logos/InventoryOrderManagemnt/TradeGecko.png";
import Ordoro from "./assets/img/products/Logos/InventoryOrderManagemnt/Ordoro.png";
import ShipStation from "./assets/img/products/Logos/InventoryOrderManagemnt/ShipStation.png";

import FedEx from "./assets/img/products/Logos/ShippingFulfillment/FedEx.png";
import UPS from "./assets/img/products/Logos/ShippingFulfillment/UPS.png";
import DHL from "./assets/img/products/Logos/ShippingFulfillment/DHL.png";
import Easyship from "./assets/img/products/Logos/ShippingFulfillment/Easyship.png";
import Shippo from "./assets/img/products/Logos/ShippingFulfillment/Shippo.png";

import Zendesk from "./assets/img/products/Logos/CustomerSupport/Zendesk.png";
import freshdesk from "./assets/img/products/Logos/CustomerSupport/freshdesk.png";
import Intercom from "./assets/img/products/Logos/CustomerSupport/Intercom.png";
import HelpScout from "./assets/img/products/Logos/CustomerSupport/HelpScout.png";

import WordPress from "./assets/img/products/Logos/ContentManagement/WordPress.png";
import Joomla from "./assets/img/products/Logos/ContentManagement/Joomla.png";
import Drupal from "./assets/img/products/Logos/ContentManagement/Drupal.png";

import SmileIo from "./assets/img/products/Logos/LoyaltyRewards/SmileIo.png";
import Yotpo from "./assets/img/products/Logos/LoyaltyRewards/Yotpo.png";
import LoyaltyLion from "./assets/img/products/Logos/LoyaltyRewards/LoyaltyLion.png";

import FacebookBusinessSuite from "./assets/img/products/Logos/SocialMediaAdvertising/FacebookBusinessSuite.png";
import Instagram from "./assets/img/products/Logos/SocialMediaAdvertising/Instagram.png";
import GoogleAds from "./assets/img/products/Logos/SocialMediaAdvertising/GoogleAds.png";
import TikTokforBusiness from "./assets/img/products/Logos/SocialMediaAdvertising/TikTokforBusiness.png";

import Shopify from "./assets/img/products/Logos/EcommercePlatforms/Shopify.png";
import WooCommerce from "./assets/img/products/Logos/EcommercePlatforms/WooCommerce.png";
import Magento from "./assets/img/products/Logos/EcommercePlatforms/Magento.png";
import BigCommerce from "./assets/img/products/Logos/EcommercePlatforms/BigCommerce.png";

import SAP from "./assets/img/products/Logos/ERP/SAP.png";
import OracleNetSuite from "./assets/img/products/Logos/ERP/OracleNetSuite.png";
import MicrosoftDynamics365 from "./assets/img/products/Logos/ERP/MicrosoftDynamics365.png";

import Avalara from "./assets/img/products/Logos/TaxCompliance/Avalara.png";
import TaxJar from "./assets/img/products/Logos/TaxCompliance/TaxJar.png";

const AIDrivenEComSolutions = () => {
  const location = useLocation();
  const [lgShow, setLgShow] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [thankYouPopup, setThankYouPopup] = useState(false);
  const [category, setCategory] = useState("All");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    interest: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios
      .post(
        "https://p506xqqura.execute-api.ap-south-1.amazonaws.com/contact",
        { ...formData, type: "contact" },
        { headers: { "Content-Type": "application/json" } },
      )
      .then(() => {
        setThankYouPopup(true);
        setFormData({ name: "", email: "", mobile: "", interest: "", message: "" });
        setLgShow(false);
        setShowThankYou(true);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("An error occurred while submitting the form. Please try again later.");
      });
  };

  const empowerIndusSlider = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleSortItems = (selectedCategory) => {
    setCategory(selectedCategory);
  };

  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="topPageBanner">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <p>Power Your Business Growth with AI-Driven </p>
                  <h2>E-Commerce Solutions</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="aiMlWrap commonCotentWrap AIChatbotsWrap">
          <div className="container">
            {/* <div className="row">
                            <div className="col-md-12">
                                <ul className="bredCrumbsWrap">
                                    <li>
                                        <Link to="/AIML">AI/ML</Link>
                                    </li>
                                    <li>OCR</li>
                                </ul>
                            </div>
                        </div> */}
            <div className="row justify-content-between">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h3>
                    Optimize Inventory, Personalize Customer Journeys, and
                    Automate Your Store Operations
                  </h3>
                  <p>
                    In today’s fast-evolving e-commerce landscape, standing out
                    requires intelligent solutions. Hummingtec’s AI-driven
                    e-commerce platform empowers businesses to deliver
                    hyper-personalized customer experiences, optimize inventory
                    management, and streamline operations. By leveraging AI and
                    advanced data analytics, we help you adapt to shifting
                    customer preferences, maximize profitability, and maintain a
                    competitive edge in the marketplace. Transform your
                    e-commerce strategy with Hummingtec’s cutting-edge AI
                    solutions designed for growth and success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="empowerIndWrap AIECommerce">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="tileWrap">
                  <h2>How AI Can Transform Your E-Commerce Business</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Slider {...empowerIndusSlider}>
                  <div className="itemOuter">
                    <div className="itemWrap clr1">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#9ceebd"
                                  opacity="1"
                                  data-original="#9ceebd"
                                ></path>
                              </clipPath>
                            </defs>
                            <g transform="matrix(1.33333 0 0 -1.33333 0 682.667)">
                              <path
                                d="M0 0h-280.683l-84.49-79.688v-396.475c0-11.301 9.161-20.462 20.463-20.462h269.313"
                                transform="translate(389.272 504.245)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                              <path
                                d="M0 0h40.329C51.63 0 60.792 9.162 60.792 20.463v319.964"
                                transform="translate(348.942 7.62)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                              <path
                                d="M0 0h64.032C75.331 0 84.49 9.16 84.49 20.458v59.23z"
                                transform="translate(24.099 424.556)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                              <path
                                d="M0 0h147.531"
                                transform="translate(143.15 396.009)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h112.924"
                                transform="translate(79.701 359.9)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h81.841"
                                transform="translate(241.208 359.9)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h112.924"
                                transform="translate(79.701 321.727)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h112.923"
                                transform="translate(241.208 321.727)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h112.924"
                                transform="translate(79.701 283.555)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0h112.923"
                                transform="translate(241.208 283.555)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0c0-43.171-34.996-78.167-78.167-78.167S-156.335-43.171-156.335 0c0 43.17 34.997 78.167 78.168 78.167C-34.996 78.167 0 43.17 0 0Z"
                                transform="translate(487.901 426.213)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="m0 0-32.772 32.764c-5.723 5.722-15.001 5.721-20.724-.001L-85.545.714c-5.712-5.712-6.033-15.36-.714-21.439l.001-.002c5.32-6.079 14.345-6.379 20.057-.667l3.425 3.425c2.191 2.191 5.938.639 5.938-2.46v-34.539c0-8.095 6.562-14.656 14.655-14.656 8.094 0 14.656 6.561 14.656 14.656v32.648c0 3.099 3.747 4.651 5.938 2.46l.865-.867c5.724-5.722 15.002-5.722 20.725 0C5.725-15.003 5.725-5.723 0 0Z"
                                transform="translate(452.611 442.498)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                                opacity="0.45"
                              ></path>
                              <path
                                d="M0 0v-57.663c0-4.094 4.103-6.919 7.928-5.456L38.21-51.541a5.837 5.837 0 0 0 4.172 0l30.282-11.578c3.825-1.463 7.928 1.362 7.928 5.456V0"
                                transform="translate(179.018 115.884)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                              <path
                                d="M0 0c12.051 9.961 27.509 15.947 44.364 15.947 38.482 0 69.677-31.196 69.677-69.677 0-38.481-31.195-69.677-69.677-69.677-38.481 0-69.676 31.196-69.676 69.677 0 9.056 1.727 17.708 4.871 25.645"
                                transform="translate(174.95 226.462)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                              <path
                                d="m0 0 7.425-15.044a3.342 3.342 0 0 1 2.518-1.83l16.603-2.413c5.68-.825 7.948-7.805 3.838-11.812L18.37-42.809a3.35 3.35 0 0 1-.962-2.961l2.836-16.535c.971-5.657-4.968-9.971-10.048-7.3l-14.849 7.807a3.349 3.349 0 0 1-3.114 0l-14.849-7.807c-5.08-2.671-11.019 1.643-10.048 7.3l2.836 16.535a3.347 3.347 0 0 1-.962 2.961l-12.014 11.71c-4.11 4.007-1.842 10.987 3.838 11.812l16.603 2.413a3.34 3.34 0 0 1 2.518 1.83L-12.42 0C-9.88 5.147-2.54 5.147 0 0Z"
                                transform="translate(225.523 209.664)"
                                fill="none"
                                stroke="#9ceebd"
                                stroke-width="15"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="10"
                                stroke-dasharray="none"
                                data-original="#9ceebd"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Personalized Recommendations</h2>
                        <p>
                          <strong>Tailored Shopping Experience – </strong> Our
                          AI algorithms analyze browsing behavior, purchase
                          history, and customer preferences to offer
                          personalized product recommendations that increase
                          engagement and conversion rates.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr2">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 1600 1600"
                        >
                          <g fill="#9ccdee">
                            <path
                              d="M552 1487.9H56c-13.3 0-24-10.7-24-24v-433.1c0-13.3 10.7-24 24-24h496c13.3 0 24 10.7 24 24v433.1c0 13.2-10.7 24-24 24zm-472-48h448v-385.1H80z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M368.6 1184H239.4c-13.3 0-24-10.7-24-24v-129.2c0-13.3 10.7-24 24-24h129.2c13.3 0 24 10.7 24 24V1160c0 13.2-10.7 24-24 24zm-105.2-48h81.2v-81.2h-81.2zM1048 1487.9H552c-13.3 0-24-10.7-24-24v-433.1c0-13.3 10.7-24 24-24h496c13.3 0 24 10.7 24 24v433.1c0 13.2-10.7 24-24 24zm-472-48h448v-385.1H576z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M864.6 1184H735.4c-13.3 0-24-10.7-24-24v-129.2c0-13.3 10.7-24 24-24h129.2c13.3 0 24 10.7 24 24V1160c0 13.2-10.7 24-24 24zm-105.2-48h81.2v-81.2h-81.2zM1544 1487.9h-496c-13.3 0-24-10.7-24-24v-433.1c0-13.3 10.7-24 24-24h496c13.3 0 24 10.7 24 24v433.1c0 13.2-10.7 24-24 24zm-472-48h448v-385.1h-448z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M1360.6 1184h-129.2c-13.3 0-24-10.7-24-24v-129.2c0-13.3 10.7-24 24-24h129.2c13.3 0 24 10.7 24 24V1160c0 13.2-10.7 24-24 24zm-105.2-48h81.2v-81.2h-81.2z"
                              fill="#9ccdee"
                              opacity="0.45"
                              data-original="#9ccdee"
                            ></path>
                          </g>
                          <path
                            fill="#9ccdee"
                            d="M800 1054.7H304c-13.3 0-24-10.7-24-24V899.5c0-13.3 10.7-24 24-24s24 10.7 24 24v107.2h448V621.6h-88.6c-13.3 0-24-10.7-24-24s10.7-24 24-24H800c13.3 0 24 10.7 24 24v433.1c0 13.3-10.7 24-24 24z"
                            opacity="0.45"
                            data-original="#9ccdee"
                          ></path>
                          <g fill="#9ccdee">
                            <path
                              d="M1296 1054.7H800c-13.3 0-24-10.7-24-24V597.6c0-13.3 10.7-24 24-24h496c13.3 0 24 10.7 24 24v433.1c0 13.3-10.7 24-24 24zm-472-48h448V621.6H824z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M1112.6 750.8H983.4c-13.3 0-24-10.7-24-24V597.6c0-13.3 10.7-24 24-24h129.2c13.3 0 24 10.7 24 24v129.2c0 13.3-10.7 24-24 24zm-105.2-48h81.2v-81.2h-81.2z"
                              fill="#9ccdee"
                              opacity="0.45"
                              data-original="#9ccdee"
                            ></path>
                          </g>
                          <g fill="#9ccdee">
                            <path
                              d="M552.5 321.2H287.7c-13.3 0-24-10.7-24-24V210c0-26.1 21.3-47.4 47.4-47.4h38.5c13.3 0 24 10.7 24 24s-10.7 24-24 24h-37.9v62.5h216.8v-62.5h-37.9c-13.3 0-24-10.7-24-24s10.7-24 24-24h38.5c26.1 0 47.4 21.3 47.4 47.4v87.1c0 13.3-10.7 24.1-24 24.1z"
                              fill="#9ccdee"
                              opacity="0.45"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M687.4 923.5H152.8c-13.3 0-24-10.7-24-24V229.3c0-13.3 10.7-24 24-24h134.9c13.3 0 24 10.7 24 24s-10.7 24-24 24H176.8v622.2h486.6V253.3H552.5c-13.3 0-24-10.7-24-24s10.7-24 24-24h134.9c13.3 0 24 10.7 24 24v670.2c0 13.3-10.7 24-24 24z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M490.6 244.5h-141c-13.3 0-24-10.7-24-24v-84.4c0-13.3 10.7-24 24-24h141c13.3 0 24 10.7 24 24v84.4c0 13.3-10.7 24-24 24zm-117-48h93v-36.4h-93zM584.8 438.2H384.7c-13.3 0-24-10.7-24-24s10.7-24 24-24h200.1c13.3 0 24 10.7 24 24s-10.8 24-24 24zM272.2 447.9c-6.1 0-12.3-2.3-17-7l-16.7-16.7c-9.4-9.4-9.4-24.6 0-33.9 9.3-9.3 24.3-9.4 33.6-.3l21.7-21.7c9.4-9.4 24.6-9.4 33.9 0 9.4 9.4 9.4 24.6 0 33.9l-38.6 38.6c-4.6 4.7-10.8 7.1-16.9 7.1zM584.8 567.4H384.7c-13.3 0-24-10.7-24-24s10.7-24 24-24h200.1c13.3 0 24 10.7 24 24s-10.8 24-24 24zM272.2 577.1c-6.4 0-12.5-2.5-17-7l-16.7-16.7c-9.4-9.4-9.4-24.6 0-33.9 9.3-9.3 24.3-9.4 33.6-.3l21.7-21.7c9.4-9.4 24.6-9.4 33.9 0 9.4 9.4 9.4 24.6 0 33.9L289.1 570c-4.5 4.5-10.6 7.1-16.9 7.1zM584.8 696.6H384.7c-13.3 0-24-10.7-24-24s10.7-24 24-24h200.1c13.3 0 24 10.7 24 24s-10.8 24-24 24zM272.2 706.3c-6.4 0-12.5-2.5-17-7l-16.7-16.7c-9.4-9.4-9.4-24.6 0-33.9 9.3-9.3 24.3-9.4 33.6-.3l21.7-21.7c9.4-9.4 24.6-9.4 33.9 0 9.4 9.4 9.4 24.6 0 33.9l-38.6 38.6c-4.5 4.5-10.6 7.1-16.9 7.1zM584.8 825.8H384.7c-13.3 0-24-10.7-24-24s10.7-24 24-24h200.1c13.3 0 24 10.7 24 24s-10.8 24-24 24zM272.2 835.4c-6.1 0-12.3-2.3-17-7l-16.7-16.7c-9.4-9.4-9.4-24.6 0-33.9 9.3-9.3 24.3-9.4 33.6-.3l21.7-21.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-38.6 38.6c-4.6 4.8-10.8 7.1-16.9 7.1z"
                              fill="#9ccdee"
                              opacity="0.45"
                              data-original="#9ccdee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Efficient Inventory Management</h2>
                        <p>
                          <strong>Accurate Demand Forecasting –</strong>{" "}
                          Optimize stock levels by accurately predicting demand
                          trends, reducing excess inventory costs and minimizing
                          stockouts.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr3">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512.002 512.002"
                        >
                          <g>
                            <path
                              d="M207.002 256.001H50c-22 0-40 18.001-40 40v100c0 21.999 18 40 40 40v40l80-40h130c21.999 0 40-18 40-40v-70M307.002 171.001h100c27.5 0 50 22.5 50 50v0c0 27.5-22.5 50-50 50h-100c-27.5 0-50-22.5-50-50v0c0-27.5 22.499-50 50-50z"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              fill="none"
                              stroke="#cb9cee"
                              stroke-width="20.0001"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.9256"
                              data-original="#cb9cee"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M307.002 221.001h.007M406.995 221.001h.007"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              fill="none"
                              stroke="#cb9cee"
                              stroke-width="29.9999"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.9256"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M357.002 81.001c12.393 0 22.5-10.107 22.5-22.5s-10.107-22.5-22.5-22.5c-12.392 0-22.5 10.107-22.5 22.5 0 12.392 10.108 22.5 22.5 22.5zM357.002 86.001v30M252.002 121.001h210c22 0 40 18 40 40v120c0 22-18 40-40 40v40l-80-40h-130c-22 0-40-18-40-40v-120c0-22 18-40 40-40zM109.996 346.001h.008M154.996 346.001h.007M199.996 346.001h.007"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              fill="none"
                              stroke="#cb9cee"
                              stroke-width="20.0001"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.9256"
                              data-original="#cb9cee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>AI-Powered Chatbots</h2>
                        <p>
                          <strong>Instant Customer Support –</strong> Provide
                          24/7 customer assistance with chatbots that handle
                          queries, suggest products, and facilitate order
                          management, improving satisfaction and reducing
                          response times.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr4">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M388.266 280.048V15.516A8.016 8.016 0 0 0 380.25 7.5H157.743a24.05 24.05 0 0 0-17.005 7.044L74.665 80.618a24.05 24.05 0 0 0-7.044 17.005V400.29a8.016 8.016 0 0 0 8.016 8.016h184.371"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M147.782 11.184v60.445c0 8.854-7.178 16.032-16.032 16.032H71.305M131.816 223.935h192.321M324.137 127.742l-96.195-48.097h-.034l-96.126 48.097M211.911 223.935V151.79h-32.064v72.145M243.976 151.79h32.065v40.081h-32.065zM308.105 223.935V119.726M147.782 223.935V119.726M211.911 280.048h112.226M211.911 312.113h72.145M211.911 344.177h48.097M444.379 296.081l-88.177 32.065 16.721 16.721L238.309 479.48a8.016 8.016 0 0 0 0 11.336l11.334 11.334a8.016 8.016 0 0 0 11.336 0l134.614-134.614 16.721 16.721 32.065-88.176zM412.315 416.323V504.5M380.25 432.355V504.5M348.185 464.419V504.5M316.121 488.468V504.5M169.366 279.113s-8.472-7.814-21.53-3.88c-11.99 3.612-14.968 20.018-6.82 26.409 4.679 3.67 11.718 6.687 21.206 10.04 21.235 7.506 13.385 37.453-8.215 37.597-8.429.056-12.37-.479-19.775-5.323M154.006 264.016v96.194"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-width="15"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              data-original="#dcdc30"
                              opacity="0.45"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Dynamic Pricing</h2>
                        <p>
                          <strong>Real-Time Pricing Strategies – </strong>{" "}
                          Adjust pricing dynamically based on market trends,
                          demand, and competition to remain competitive and
                          boost profits.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr5">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 96 96"
                        >
                          <g>
                            <path
                              d="M60.5 80h-5c-1.65 0-3 1.35-3 3v2c0 1.65 1.35 3 3 3h5c1.65 0 3-1.35 3-3v-2c0-1.65-1.35-3-3-3zm1 5c0 .55-.45 1-1 1h-5c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h5c.55 0 1 .45 1 1zM13 51h12c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1zm1-8h10v6H14zM43 49h9c.55 0 1-.45 1-1s-.45-1-1-1h-9c-.55 0-1 .45-1 1s.45 1 1 1zM30 57H13c-.55 0-1 .45-1 1s.45 1 1 1h17c.55 0 1-.45 1-1s-.45-1-1-1z"
                              fill="#ff9393"
                              opacity="0.45"
                              data-original="#ff9393"
                            ></path>
                            <path
                              d="M89.36 41.09c-1.12-.04-2.24-.16-3.36-.33V9c0-2.76-2.24-5-5-5H35c-2.76 0-5 2.24-5 5v9H8c-2.21 0-4 1.79-4 4v40c0 2.21 1.79 4 4 4h22v21c0 2.76 2.24 5 5 5h46c2.76 0 5-2.24 5-5V76.82c3.83-3.44 6-8.29 6-13.48V43.86c0-1.49-1.16-2.71-2.64-2.76zM66 6v1c0 1.1-.9 2-2 2H52c-1.1 0-2-.9-2-2V6zM32 9c0-1.65 1.35-3 3-3h13v1c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V6h13c1.65 0 3 1.35 3 3v31.43c-3.03-.64-5.95-1.73-8.68-3.24-.1-.06-.21-.09-.32-.13V22.01c0-2.21-1.79-4-4-4H32v-9zM6 28h67v7H6zm2-8h63c1.1 0 2 .9 2 2v4H6v-4c0-1.1.9-2 2-2zM6 62V37h67v.05c-.11.04-.22.07-.32.13a31.224 31.224 0 0 1-14.04 3.91c-.77.03-1.45.37-1.93.91H33c-.55 0-1 .45-1 1s.45 1 1 1h23v19.34c0 .22.01.44.02.66H8c-1.1 0-2-.9-2-2zm75 28H35c-1.65 0-3-1.35-3-3V66h24.2a18.02 18.02 0 0 0 6.61 11.51l9.46 7.57c.51.41 1.12.61 1.73.61s1.22-.2 1.73-.61L84 78.46V87c0 1.65-1.35 3-3 3zm9-26.66c0 4.93-2.21 9.53-6.06 12.61l-9.46 7.57c-.28.22-.67.22-.95 0l-9.46-7.57a16.061 16.061 0 0 1-6.06-12.61V43.86c0-.41.31-.75.72-.76 1.84-.07 3.69-.29 5.5-.66 3.29-.68 6.47-1.86 9.43-3.5a.73.73 0 0 1 .7 0c2.97 1.64 6.14 2.82 9.43 3.5 1.8.37 3.65.59 5.5.66.4.01.72.35.72.76v19.48z"
                              fill="#ff9393"
                              opacity="1"
                              data-original="#ff9393"
                            ></path>
                            <path
                              d="M78.66 55.93 73 61.59l-3.18-3.18a.996.996 0 1 0-1.41 1.41l3.89 3.89c.2.2.45.29.71.29s.51-.1.71-.29l6.36-6.36a.996.996 0 1 0-1.41-1.41z"
                              fill="#ff9393"
                              opacity="0.45"
                              data-original="#ff9393"
                            ></path>
                            <path
                              d="M74 47c-6.62 0-12 5.38-12 12s5.38 12 12 12 12-5.38 12-12-5.38-12-12-12zm0 22c-5.51 0-10-4.49-10-10s4.49-10 10-10 10 4.49 10 10-4.49 10-10 10z"
                              fill="#ff9393"
                              opacity="0.45"
                              data-original="#ff9393"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Fraud Detection</h2>
                        <p>
                          <strong>Secure Transactions –</strong> Machine
                          learning algorithms identify unusual transaction
                          patterns, minimizing the risk of chargebacks and
                          financial losses due to fraud.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr6">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M37 54h-2v-9.8a1 1 0 0 0-2 0V54H7V34h8.32a1 1 0 0 0 0-2H6a1 1 0 0 0-1 1v21H3a1 1 0 0 0-1 1v2a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5v-2a1 1 0 0 0-1-1zm-1 3a3 3 0 0 1-3 3h-2v-1a1 1 0 0 0-2 0v1H11v-1a1 1 0 0 0-2 0v1H7a3 3 0 0 1-3-3v-1h32zM54 8h2a1 1 0 0 0 0-2h-2a3 3 0 0 0-3 3v1h-1a1 1 0 0 0 0 2h1v3a1 1 0 0 0 2 0v-3h1a1 1 0 0 0 0-2h-1V9a1 1 0 0 1 1-1z"
                              fill="#7a7ae0"
                              opacity="1"
                              data-original="#7a7ae0"
                            ></path>
                            <path
                              d="M59 2H47a3 3 0 0 0-3 3v2a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H47a1 1 0 0 1-1-1v-6a1 1 0 0 0-2 0v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zM49 42a4 4 0 1 0 4-4 4 4 0 0 0-4 4zm6 0a2 2 0 1 1-2-2 2 2 0 0 1 2 2z"
                              fill="#7a7ae0"
                              opacity="0.45"
                              data-original="#7a7ae0"
                            ></path>
                            <path
                              d="M59 33H47a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2a1 1 0 0 0-2 0v2a1 1 0 0 1-1 1H47a1 1 0 0 1-1-1V36a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 0 2 0v-6a3 3 0 0 0-3-3zM24.47 13.85A1 1 0 0 0 25 14a1 1 0 0 0 .45-.11l6-3a1 1 0 0 0 0-1.78l-6-3A1 1 0 0 0 24 7v6a1 1 0 0 0 .47.85zM26 8.62 28.76 10 26 11.38z"
                              fill="#7a7ae0"
                              opacity="0.45"
                              data-original="#7a7ae0"
                            ></path>
                            <path
                              d="M27 19a9 9 0 1 0-9-9 9 9 0 0 0 9 9zm0-16a7 7 0 1 1-7 7 7 7 0 0 1 7-7zM37 23a1 1 0 0 0 .8-.4l3-4a1 1 0 0 0-1.6-1.2l-3 4a1 1 0 0 0 .2 1.4 1 1 0 0 0 .6.2zM39.2 26.6a1 1 0 0 0 .8.4 1 1 0 0 0 .6-.2l4-3a1 1 0 1 0-1.2-1.6l-4 3a1 1 0 0 0-.2 1.4zM49 28.8a1 1 0 0 0-1.2-.8l-5 1a1 1 0 0 0 .2 2h.2l5-1a1 1 0 0 0 .8-1.2zM3 29h12a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zm1-16h10v14H4z"
                              fill="#7a7ae0"
                              opacity="0.45"
                              data-original="#7a7ae0"
                            ></path>
                            <path
                              d="M11 15H9a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM11 19H7a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM11 23H7a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2zM36.12 28.7a1 1 0 0 0-1.74 1l4.41 7.63-16 6H22.64l-2.6 1.5-1.73 1a2 2 0 0 1-1.52.2 2 2 0 0 1-1.21-.93l-2-3.46a2 2 0 0 1 .75-2.64l3.46-2 2.5 4.33a1 1 0 0 0 .87.5 1 1 0 0 0 .87-1.5l-2.58-4.46L32 25.52l.41.71a1 1 0 1 0 1.74-1l-1-1.73a1 1 0 0 0-.69-.48 1 1 0 0 0-.82.21l-14 11.54-4.26 2.46a4 4 0 0 0-1.84 4.53l-1 .57a3 3 0 0 0 .72 5.5 3 3 0 0 0 .78.1 3.06 3.06 0 0 0 1.5-.4l1-.57A3.88 3.88 0 0 0 16.29 48a3.79 3.79 0 0 0 1.05.14 3.94 3.94 0 0 0 2-.54l.87-.5 2 3.47a3 3 0 0 0 4.09 1.1 3 3 0 0 0 1.1-4.1l-1.82-3.17 15-5.63a1 1 0 0 0 .59-.6 1 1 0 0 0-.07-.83zM12.5 45.79a1 1 0 0 1-.76.1 1 1 0 0 1-.61-.46 1 1 0 0 1-.1-.76 1 1 0 0 1 .47-.61l.87-.5 1 1.73zm13.16 2.8a1 1 0 0 1 .1.76 1 1 0 0 1-.47.6 1 1 0 0 1-1.36-.36l-2-3.47 1.66-.95h.08z"
                              fill="#7a7ae0"
                              opacity="1"
                              data-original="#7a7ae0"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Advanced Customer Segmentation</h2>
                        <p>
                          <strong>Targeted Marketing Campaigns –</strong>{" "}
                          Segment your audience using behavior, demographics,
                          and preferences to create more effective marketing
                          strategies that drive higher engagement and ROI.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr1">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              d="M57 2H7C4.24 2 2 4.24 2 7v42c0 2.76 2.24 5 5 5h34.64c.55 0 1-.45 1-1s-.45-1-1-1H7c-1.65 0-3-1.35-3-3V10h56v39c0 .6-.18 1.18-.51 1.67-.31.46-.19 1.08.27 1.39s1.08.19 1.39-.27c.56-.83.85-1.79.85-2.79V7c0-2.76-2.24-5-5-5zM4 7c0-1.65 1.35-3 3-3h37v4H4zm42 1V4h11c1.65 0 3 1.35 3 3v1z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M50.72 46.97c-1.34-1.14-3.25-1.25-4.72-.39l-2.73-2.73c2.31-2.64 3.72-6.08 3.72-9.86 0-1.5-.22-2.97-.65-4.38-.1-.45-.5-.78-.98-.78-.55 0-1 .45-1 1.01 0 .1.02.2.05.3.39 1.24.58 2.53.58 3.85 0 7.17-5.83 13-13 13s-13-5.83-13-13 5.83-13 13-13c2.99 0 5.8.99 8.12 2.86a1.002 1.002 0 1 0 1.26-1.56c-2.69-2.16-5.93-3.3-9.38-3.3-8.27 0-15 6.73-15 15s6.73 15 15 15c3.78 0 7.22-1.41 9.86-3.73l2.72 2.72c-.86 1.46-.76 3.37.39 4.72l6.7 7.86c.74.86 1.81 1.38 2.94 1.43h.16c1.08 0 2.12-.43 2.88-1.19l1.15-1.15c.8-.8 1.23-1.91 1.19-3.04s-.56-2.2-1.43-2.94l-7.86-6.7zm6.68 11.27-1.15 1.15c-.41.41-.96.63-1.55.61-.58-.02-1.11-.28-1.49-.73l-6.7-7.86c-.7-.82-.65-2.05.11-2.81.4-.4.93-.6 1.46-.6.48 0 .96.16 1.34.49l7.86 6.7c.45.38.7.91.73 1.49.02.58-.19 1.13-.6 1.55z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M30.71 29.29a.996.996 0 0 0-1.41 0l-6 6a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.29-5.29 4.29 4.29c.19.19.46.28.72.29.27 0 .53-.12.71-.31L51 19.51V23c0 .55.45 1 1 1s1-.45 1-1v-6c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.68l-14.7 15.57-4.27-4.27z"
                              fill="#9ceebd"
                              opacity="0.45"
                              data-original="#9ceebd"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Improved Search Experience</h2>
                        <p>
                          <strong>NLP-Powered Searches –</strong> Natural
                          language processing (NLP) ensures that customers find
                          exactly what they are looking for, increasing
                          conversion rates.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr5">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M366.222 343.719a140.537 140.537 0 0 0 7.012-9.638l33.09 4.472a10.01 10.01 0 0 0 10.85-6.82l13.335-41.044a10.002 10.002 0 0 0-4.769-11.895l-29.404-15.836a137.63 137.63 0 0 0 0-11.915l29.406-15.837a10 10 0 0 0 4.77-11.895l-13.336-41.044c-1.493-4.597-6.065-7.456-10.85-6.82l-33.09 4.472a139.958 139.958 0 0 0-7.012-9.638l14.481-30.097a10 10 0 0 0-3.133-12.426l-34.914-25.366a10.002 10.002 0 0 0-12.786.859L305.749 126.3a139.302 139.302 0 0 0-11.355-3.688l-5.975-33.071a10 10 0 0 0-9.841-8.222h-43.156c-4.837 0-8.98 3.462-9.841 8.223l-5.974 33.07a139.186 139.186 0 0 0-11.355 3.688l-24.123-23.049a10 10 0 0 0-12.786-.859l-34.914 25.365a9.999 9.999 0 0 0-3.133 12.426l14.481 30.096a140.264 140.264 0 0 0-7.013 9.639l-33.089-4.472a10.012 10.012 0 0 0-10.85 6.819l-13.337 41.044a10.002 10.002 0 0 0 4.769 11.896l29.406 15.837a137.607 137.607 0 0 0 0 11.914l-29.406 15.837a10.002 10.002 0 0 0-4.769 11.895l13.335 41.044a10.008 10.008 0 0 0 10.85 6.82l33.09-4.472a140.384 140.384 0 0 0 7.012 9.638l-14.48 30.097a10 10 0 0 0 3.133 12.426l34.913 25.366a9.997 9.997 0 0 0 12.786-.859l24.123-23.049a139.302 139.302 0 0 0 11.355 3.688l5.975 33.071a10 10 0 0 0 9.841 8.222h43.155c4.837 0 8.98-3.462 9.841-8.222l5.975-33.071a139.438 139.438 0 0 0 11.355-3.688l24.123 23.05a10 10 0 0 0 12.786.859l34.913-25.366a9.999 9.999 0 0 0 3.133-12.426zm-6.601-25.536a120.05 120.05 0 0 1-12.724 17.487 9.998 9.998 0 0 0-1.487 10.924l13.651 28.373-21.409 15.555-22.74-21.728a10.002 10.002 0 0 0-10.852-1.959 118.96 118.96 0 0 1-20.572 6.681 10 10 0 0 0-7.633 7.976l-5.635 31.188h-26.444l-5.635-31.188a10.003 10.003 0 0 0-7.634-7.977 118.739 118.739 0 0 1-20.571-6.68 9.999 9.999 0 0 0-10.852 1.959l-22.74 21.728-21.409-15.555 13.651-28.373a10 10 0 0 0-1.488-10.925 120.22 120.22 0 0 1-12.724-17.487 10.006 10.006 0 0 0-9.923-4.781l-31.186 4.215-8.177-25.17 27.719-14.928a10.003 10.003 0 0 0 5.218-9.698 119.756 119.756 0 0 1 0-21.639 10.001 10.001 0 0 0-5.218-9.698l-27.719-14.928 8.179-25.17 31.185 4.215a10.013 10.013 0 0 0 9.924-4.781 119.913 119.913 0 0 1 12.723-17.486 9.996 9.996 0 0 0 1.489-10.926l-13.652-28.373 21.41-15.555 22.74 21.729a10 10 0 0 0 10.853 1.959 118.784 118.784 0 0 1 20.571-6.682 10 10 0 0 0 7.633-7.976l5.634-31.188h26.445l5.635 31.188a10.003 10.003 0 0 0 7.634 7.977 118.675 118.675 0 0 1 20.57 6.68 9.995 9.995 0 0 0 10.853-1.959l22.74-21.728 21.41 15.555-13.652 28.373a10 10 0 0 0 1.488 10.925 120.062 120.062 0 0 1 12.723 17.486 10.009 10.009 0 0 0 9.924 4.782l31.186-4.215 8.178 25.17-27.719 14.928a10.002 10.002 0 0 0-5.219 9.698c.654 7.294.654 14.371-.002 21.633a10.002 10.002 0 0 0 5.218 9.704l27.72 14.928-8.178 25.17-31.186-4.215a9.998 9.998 0 0 0-9.924 4.782z"
                              fill="#ff9393"
                              opacity="1"
                              data-original="#ff9393"
                            ></path>
                            <path
                              d="M257 183c-40.804 0-74 33.196-74 74s33.196 74 74 74 74-33.196 74-74-33.196-74-74-74zm0 128c-29.775 0-54-24.225-54-54s24.225-54 54-54 54 24.225 54 54-24.225 54-54 54zM501 1H401c-5.522 0-10 4.478-10 10v100c0 5.522 4.478 10 10 10h100c5.522 0 10-4.478 10-10V11c0-5.522-4.478-10-10-10zm-10 100h-80V21h30v10c0 5.522 4.478 10 10 10s10-4.478 10-10V21h30zM356.708 468.388C325.132 483.393 291.248 491 256 491c-35.249 0-69.133-7.607-100.708-22.612-4.988-2.368-10.954-.248-13.324 4.74s-.248 10.954 4.74 13.324C180.987 502.741 217.758 511 256 511c38.241 0 75.012-8.259 109.292-24.548 4.988-2.37 7.11-8.336 4.74-13.324-2.37-4.987-8.335-7.11-13.324-4.74zM38.872 370.032c4.988-2.37 7.11-8.336 4.74-13.324C28.607 325.132 21 291.248 21 256s7.607-69.132 22.612-100.708c2.37-4.988.248-10.954-4.74-13.324-4.988-2.369-10.953-.247-13.324 4.74C9.259 180.988 1 217.759 1 256s8.259 75.012 24.548 109.292c2.376 5 8.347 7.104 13.324 4.74zM473.129 141.968c-4.989 2.37-7.111 8.335-4.741 13.323C483.392 186.872 491 220.756 491 256c0 35.248-7.607 69.132-22.612 100.708-2.37 4.988-.248 10.954 4.74 13.324 4.981 2.366 10.95.256 13.324-4.74C502.741 331.012 511 294.241 511 256c0-38.236-8.259-75.008-24.548-109.291-2.37-4.989-8.338-7.112-13.323-4.741zM155.292 43.612C186.867 28.607 220.751 21 256 21c35.248 0 69.132 7.607 100.708 22.612 4.99 2.372 10.954.248 13.324-4.74s.248-10.954-4.74-13.324C331.012 9.259 294.241 1 256 1c-38.242 0-75.013 8.259-109.292 24.548-4.988 2.37-7.11 8.336-4.74 13.324 2.376 5 8.347 7.104 13.324 4.74zM11 121h100c5.522 0 10-4.478 10-10V11c0-5.522-4.478-10-10-10H11C5.478 1 1 5.478 1 11v100c0 5.522 4.478 10 10 10zM21 21h30v10c0 5.522 4.478 10 10 10s10-4.478 10-10V21h30v80H21zM501 391H401c-5.522 0-10 4.478-10 10v100c0 5.522 4.478 10 10 10h100c5.522 0 10-4.478 10-10V401c0-5.522-4.478-10-10-10zm-10 100h-80v-80h30v10c0 5.522 4.478 10 10 10s10-4.478 10-10v-10h30zM111 391H11c-5.522 0-10 4.478-10 10v100c0 5.522 4.478 10 10 10h100c5.522 0 10-4.478 10-10V401c0-5.522-4.478-10-10-10zm-10 100H21v-80h30v10c0 5.522 4.478 10 10 10s10-4.478 10-10v-10h30z"
                              fill="#ff9393"
                              opacity="0.45"
                              data-original="#ff9393"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Supply Chain Optimization</h2>
                        <p>
                          <strong>Faster, Efficient Fulfillment –</strong>{" "}
                          Optimize delivery routes and predict supply chain
                          bottlenecks, reducing shipping times and costs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="itemOuter">
                    <div className="itemWrap clr4">
                      <div className="icoWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 64 64"
                        >
                          <g>
                            <path
                              fill="#dcdc30"
                              d="M55.8 15.4c-4 0-7.2-3.2-7.2-7.2S51.8 1 55.8 1 63 4.2 63 8.2s-3.3 7.2-7.2 7.2z"
                              opacity="0"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              fill="#dcdc30"
                              d="M60.6 13.5c-1.3 1.2-2.9 1.8-4.8 1.8-1.8 0-3.5-.7-4.8-1.9.4-2.3 2.4-4.1 4.8-4.1 2.4.1 4.4 1.9 4.8 4.2z"
                              opacity="0"
                            ></path>
                            <circle
                              cx="55.8"
                              cy="6.9"
                              r="2.6"
                              fill="#dcdc30"
                              opacity="0"
                            ></circle>
                            <circle
                              cx="32.2"
                              cy="12.6"
                              r="7.2"
                              fill="#dcdc30"
                              opacity="0"
                              data-original="#dcdc30"
                            ></circle>
                            <path
                              fill="#dcdc30"
                              d="M36.9 17.9c-1.3 1.2-2.9 1.8-4.8 1.8-1.8 0-3.5-.7-4.8-1.9.4-2.3 2.4-4.1 4.8-4.1 2.5.2 4.5 1.9 4.8 4.2z"
                              opacity="0"
                            ></path>
                            <circle
                              cx="32.2"
                              cy="11.3"
                              r="2.6"
                              fill="#dcdc30"
                              opacity="0"
                            ></circle>
                            <path
                              fill="#dcdc30"
                              d="M51.3 38.9c-4 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.2 7.2 3.2 7.2 7.1-3.2 7.2-7.2 7.2z"
                              opacity="0"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              fill="#dcdc30"
                              d="M56.1 37.1c-1.3 1.2-2.9 1.8-4.8 1.8-1.8 0-3.5-.7-4.8-1.9.4-2.3 2.4-4.1 4.8-4.1 2.4.1 4.4 1.9 4.8 4.2z"
                              opacity="0"
                            ></path>
                            <circle
                              cx="51.3"
                              cy="30.4"
                              r="2.6"
                              fill="#dcdc30"
                              opacity="0"
                            ></circle>
                            <path
                              fill="#dcdc30"
                              d="m37.4 52.9 5.1-5.1c.7-.7.7-1.7 0-2.4l-5.2-5.2c-.7-.7-1.7-.7-2.4 0l-5.1 5.1z"
                              opacity="0"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              fill="#dcdc30"
                              d="m18.7 34.1 5.1-5.1c.7-.7.7-1.7 0-2.4l-5.2-5.2c-.7-.7-1.7-.7-2.4 0L11 26.5z"
                              opacity="0"
                              data-original="#dcdc30"
                            ></path>
                            <g
                              fill="none"
                              stroke="#dcdc30"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                            >
                              <g stroke-width="1.5">
                                <path
                                  d="m53.7 18.1-.7 3.7M42 10.2l3.7-.9M43.9 24.9 39.2 20"
                                  opacity="0.45"
                                ></path>
                              </g>
                              <path d="m32.8 48.3 4.6 4.6" opacity="1"></path>
                              <path
                                stroke-width="1.5"
                                d="M2.6 37c1-2.3 2.4-4.4 4.2-6.2l9.3-9.4c.7-.6 1.7-.6 2.4 0l5.2 5.2c.7.7.7 1.7 0 2.4l-9.5 9.5c-2.9 2.9-3.4 7.6-.8 10.8 3 3.6 8.4 3.8 11.7.6l9.7-9.7c.7-.6 1.7-.6 2.4 0l5.2 5.2c.7.6.7 1.7 0 2.4l-9.7 9.7c-7.7 7.7-20.5 7.3-27.6-1.3-2.3-2.7-3.6-5.9-4-9.3M1.1 43.6c.1-1.1.2-2.2.5-3.3"
                                opacity="1"
                              ></path>
                              <path d="m14 29.5 4.7 4.6" opacity="1"></path>
                              <path
                                stroke-width="1.5"
                                d="M51.3 38.9c-4 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.2 7.2 3.2 7.2 7.1-3.2 7.2-7.2 7.2zM32.1 5.5c4 0 7.2 3.2 7.2 7.2 0 3.9-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2v-.1M26.1 8.9c.6-1 1.4-1.8 2.4-2.3"
                                opacity="1"
                              ></path>
                            </g>
                            <path
                              d="M55.8 15.4c-4 0-7.2-3.2-7.2-7.2S51.8 1 55.8 1 63 4.2 63 8.2s-3.3 7.2-7.2 7.2z"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                              stroke-width="1."
                              data-original="#dcdc30"
                            ></path>
                            <g
                              fill="none"
                              stroke="#dcdc30"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                            >
                              <circle
                                cx="55.8"
                                cy="6.9"
                                r="2.6"
                                opacity="1"
                              ></circle>
                              <path
                                d="M52.5 10.7c.9-.8 2-1.3 3.3-1.3s2.4.5 3.3 1.3"
                                opacity="1"
                              ></path>
                            </g>
                            <g
                              fill="none"
                              stroke="#dcdc30"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                            >
                              <circle
                                cx="32.2"
                                cy="11.3"
                                r="2.6"
                                opacity="1"
                              ></circle>
                              <path
                                d="M28.9 15.2c.9-.8 2-1.3 3.3-1.3s2.4.5 3.3 1.3"
                                opacity="1"
                              ></path>
                            </g>
                            <g
                              fill="none"
                              stroke="#dcdc30"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10"
                            >
                              <circle
                                cx="51.3"
                                cy="30.4"
                                r="2.6"
                                opacity="1"
                              ></circle>
                              <path
                                d="M48 34.3c.9-.8 2-1.3 3.3-1.3s2.4.5 3.3 1.3"
                                opacity="1"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Enhanced Customer Retention</h2>
                        <p>
                          <strong>Predict and Prevent Churn –</strong> Identify
                          at-risk customers and re-engage them with personalized
                          offers, incentives, or loyalty programs.
                        </p>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap flexRevMob">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Why Choose Our E-Commerce Solution?</h2>
                  <ul>
                    <li>
                      <strong>1. Seamless Integration:</strong> Our platform is
                      compatible with leading e-commerce tools, making it easy
                      to integrate and scale.
                    </li>
                    <li>
                      <strong>2. Custom Configuration: </strong>We tailor our
                      solution to align with your business goals and customer
                      service needs.
                    </li>
                    <li>
                      <strong>3. Training and Support:</strong> Benefit from
                      comprehensive training and ongoing support to maximize
                      your ROI.
                    </li>
                    <li>
                      <strong>4. Data-Driven Insights:</strong> Access advanced
                      analytics to refine your marketing, inventory, and
                      customer service strategies.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={opticalCharRecImg2} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="techWrap techFilterWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="titleWrap">
                  <h2>Tech stack</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul className="topBtnlistWrap">
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("All")}
                    >
                      All
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("PaymentGateways")}
                    >
                      Payment Gateways
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("CRM")}
                    >
                      CRM
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("MarketingAutomation")}
                    >
                      Marketing Automation
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("AnalyticsReporting")}
                    >
                      Analytics and Reporting
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() =>
                        handleSortItems("InventoryOrderManagement")
                      }
                    >
                      Inventory and Order Management
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("ShippingFulfillment")}
                    >
                      Shipping and Fulfillment
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("CustomerSupport")}
                    >
                      Customer Support
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("ContentManagement")}
                    >
                      Content Management
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("LoyaltyRewards")}
                    >
                      Loyalty and Rewards
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("SocialMediaAdvertising")}
                    >
                      Social Media and Advertising
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("EcommercePlatforms")}
                    >
                      E-commerce Platforms
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("ERP")}
                    >
                      Enterprise Resource Planning (ERP)
                    </button>
                  </li>
                  <li>
                    <button
                      className="btn"
                      onClick={() => handleSortItems("TaxCompliance")}
                    >
                      Tax Compliance
                    </button>
                  </li>
                </ul>
              </div>
              <div className="col-md-12">
                <ul className="sortListWrap">
                  {category === "All" ? (
                    <>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={PayPal} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>PayPal</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={stripe} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Stripe</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={square} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Square</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={Authorizenet}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Authorize.net</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={AmazonPay} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Amazon Pay</h2>
                          </div>
                        </div>
                      </li>

                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={Salesforce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Salesforce</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={HubSpotCRM}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>HubSpot CRM</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={ZohoCRM} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Zoho CRM</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={MicrosoftDynamics}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Microsoft Dynamics</h2>
                          </div>
                        </div>
                      </li>

                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Mailchimp} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Mailchimp</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={ActiveCampaign}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>ActiveCampaign</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Marketo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Marketo</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Klaviyo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Klaviyo</h2>
                          </div>
                        </div>
                      </li>

                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={GoogleAnalytics}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Google Analytics</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={FacebookPixel}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Facebook Pixel</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Hotjar} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Hotjar</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Tableau} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Tableau</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={PowerBI} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Power BI</h2>
                          </div>
                        </div>
                      </li>

                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={NetSuite} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>NetSuite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={TradeGecko}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>TradeGecko (QuickBooks Commerce)</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Ordoro} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Ordoro</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={ShipStation}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>ShipStation</h2>
                          </div>
                        </div>
                      </li>

                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={FedEx} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>FedEx</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={UPS} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>UPS</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={DHL} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>DHL</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Easyship} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Easyship</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Shippo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Shippo</h2>
                          </div>
                        </div>
                      </li>

                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Zendesk} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Zendesk</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={freshdesk} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Freshdesk</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Intercom} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Intercom</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={HelpScout} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Help Scout</h2>
                          </div>
                        </div>
                      </li>

                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={WordPress} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>WordPress</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Joomla} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Joomla</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Drupal} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Drupal</h2>
                          </div>
                        </div>
                      </li>

                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={SmileIo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Smile.io</h2>
                          </div>
                        </div>
                      </li>
                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Yotpo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Yotpo</h2>
                          </div>
                        </div>
                      </li>
                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={LoyaltyLion}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>LoyaltyLion</h2>
                          </div>
                        </div>
                      </li>

                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={FacebookBusinessSuite}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Facebook Business Suite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Instagram} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Instagram</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={GoogleAds} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Google Ads</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={TikTokforBusiness}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>TikTok for Business</h2>
                          </div>
                        </div>
                      </li>

                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Shopify} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Shopify</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={WooCommerce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>WooCommerce</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Magento} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Magento</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={BigCommerce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>BigCommerce</h2>
                          </div>
                        </div>
                      </li>

                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={SAP} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>SAP</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={OracleNetSuite}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Oracle NetSuite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={MicrosoftDynamics365}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Microsoft Dynamics 365</h2>
                          </div>
                        </div>
                      </li>

                      <li className="TaxComplianceTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Avalara} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Avalara</h2>
                          </div>
                        </div>
                      </li>
                      <li className="TaxComplianceTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={TaxJar} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>TaxJar</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "PaymentGateways" ? (
                    <>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={PayPal} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>PayPal</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={stripe} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Stripe</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={square} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Square</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={Authorizenet}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Authorize.net</h2>
                          </div>
                        </div>
                      </li>
                      <li className="PaymentGatewaysTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={AmazonPay} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Amazon Pay</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "CRM" ? (
                    <>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={Salesforce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Salesforce</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={HubSpotCRM}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>HubSpot CRM</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={ZohoCRM} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Zoho CRM</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CRMTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={MicrosoftDynamics}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Microsoft Dynamics</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "MarketingAutomation" ? (
                    <>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Mailchimp} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Mailchimp</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={ActiveCampaign}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>ActiveCampaign</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Marketo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Marketo</h2>
                          </div>
                        </div>
                      </li>
                      <li className="MarketingAutomationTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Klaviyo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Klaviyo</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "AnalyticsReporting" ? (
                    <>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={GoogleAnalytics}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Google Analytics</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={FacebookPixel}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Facebook Pixel</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Hotjar} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Hotjar</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Tableau} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Tableau</h2>
                          </div>
                        </div>
                      </li>
                      <li className="AnalyticsReportingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={PowerBI} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Power BI</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "InventoryOrderManagement" ? (
                    <>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={NetSuite} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>NetSuite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={TradeGecko}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>TradeGecko (QuickBooks Commerce)</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Ordoro} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Ordoro</h2>
                          </div>
                        </div>
                      </li>
                      <li className="InventoryOrderManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={ShipStation}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>ShipStation</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "ShippingFulfillment" ? (
                    <>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={FedEx} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>FedEx</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={UPS} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>UPS</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={DHL} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>DHL</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Easyship} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Easyship</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ShippingFulfillmentTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Shippo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Shippo</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "CustomerSupport" ? (
                    <>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Zendesk} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Zendesk</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={freshdesk} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Freshdesk</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Intercom} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Intercom</h2>
                          </div>
                        </div>
                      </li>
                      <li className="CustomerSupportTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={HelpScout} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Help Scout</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "ContentManagement" ? (
                    <>
                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={WordPress} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>WordPress</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Joomla} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Joomla</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ContentManagementTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Drupal} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Drupal</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "LoyaltyRewards" ? (
                    <>
                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={SmileIo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Smile.io</h2>
                          </div>
                        </div>
                      </li>
                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Yotpo} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Yotpo</h2>
                          </div>
                        </div>
                      </li>
                      <li className="LoyaltyRewardsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={LoyaltyLion}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>LoyaltyLion</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "SocialMediaAdvertising" ? (
                    <>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={FacebookBusinessSuite}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Facebook Business Suite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Instagram} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Instagram</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={GoogleAds} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Google Ads</h2>
                          </div>
                        </div>
                      </li>
                      <li className="SocialMediaAdvertisingTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={TikTokforBusiness}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>TikTok for Business</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "EcommercePlatforms" ? (
                    <>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Shopify} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Shopify</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={WooCommerce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>WooCommerce</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Magento} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Magento</h2>
                          </div>
                        </div>
                      </li>
                      <li className="EcommercePlatformsTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={BigCommerce}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>BigCommerce</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : category === "ERP" ? (
                    <>
                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={SAP} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>SAP</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={OracleNetSuite}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Oracle NetSuite</h2>
                          </div>
                        </div>
                      </li>
                      <li className="ERPTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img
                              src={MicrosoftDynamics365}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="dataWrap">
                            <h2>Microsoft Dynamics 365</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  ) : (
                    <>
                      <li className="TaxComplianceTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={Avalara} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>Avalara</h2>
                          </div>
                        </div>
                      </li>
                      <li className="TaxComplianceTech">
                        <div className="itemWrap">
                          <div className="iconWrap">
                            <img src={TaxJar} className="img-fluid" alt="" />
                          </div>
                          <div className="dataWrap">
                            <h2>TaxJar</h2>
                          </div>
                        </div>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="reachOutWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="dataWrap">
                  <h2>Get Started with AI-Driven E-Commerce</h2>
                  <p>
                    Ready to revolutionize your e-commerce business? Contact us
                    today and let's unlock new growth opportunities together.
                  </p>
                  <button className="btn" onClick={() => setLgShow(true)}>
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="titleWrap">
            <h2>Let's get in touch</h2>
            <p>
              Kindly fill out the form below, and our team will promptly respond
              to your inquiries.
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <ul className="formList">
              <li>
                <div className="inputField">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Mobile Number</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField selectField">
                  <label>I'm interested in:</label>
                  <select
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                  >
                    <option value="">Select an option</option>
                    <option>Artificial Intelligence</option>
                    <option>Machine Learning</option>
                    <option>Custom GPT</option>
                    <option>Blockchain/Etherium</option>
                    <option>E-Commerce/Shopping Cart</option>
                    <option>Salesforce CRM</option>
                    <option>Zoho CRM</option>
                    <option>Custom CRM</option>
                    <option>Website Development</option>
                    <option>SEO</option>
                    <option>Social Media Management</option>
                    <option>Mobile Application Development</option>
                    <option>Custom Application Development</option>
                    <option>Security and Testing</option>
                    <option>Other</option>
                  </select>
                </div>
              </li>
              <li className="full">
                <div className="inputField">
                  <label>Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </li>
              <li className="full">
                <div className="ctaWrap">
                  <button type="submit" className="btnSubmti">
                    Submit
                  </button>
                </div>
              </li>
            </ul>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={showThankYou}
        onHide={() => setShowThankYou(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="thankYouPopup">
            <h3>Thank you for contacting us!</h3>
            <p>We will respond to your inquiry shortly.</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default AIDrivenEComSolutions;
